import moment from 'moment';

import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { USER_TYPES } from '../pages/Admin/shared/static-options';
import DynamicAPI from '../shared/axios';

// actions

const GET_BIG_NUMBERS = 'luft/dashboard-completed/GET_BIG_NUMBERS';
const GET_BIG_NUMBERS_SUCCESS =
  'luft/dashboard-completed/GET_BIG_NUMBERS_SUCCESS';
const GET_BIG_NUMBERS_FAILURE =
  'luft/dashboard-completed/GET_BIG_NUMBERS_FAILURE';

const GET_PERIOD_LIST = 'luft/dashboard-completed/GET_PERIOD_LIST';
const GET_PERIOD_LIST_SUCCESS =
  'luft/dashboard-completed/GET_PERIOD_LIST_SUCCESS';
const GET_PERIOD_LIST_FAILURE =
  'luft/dashboard-completed/GET_PERIOD_LIST_FAILURE';

const GET_COMPARATIVE = 'luft/dashboard-completed/GET_COMPARATIVE';
const GET_COMPARATIVE_SUCCESS =
  'luft/dashboard-completed/GET_COMPARATIVE_SUCCESS';
const GET_COMPARATIVE_FAILURE =
  'luft/dashboard-completed/GET_COMPARATIVE_FAILURE';

const GET_COMPARATIVE_BY = 'luft/dashboard-completed/GET_COMPARATIVE_BY';
const GET_COMPARATIVE_BY_SUCCESS =
  'luft/dashboard-completed/GET_COMPARATIVE_BY_SUCCESS';
const GET_COMPARATIVE_BY_FAILURE =
  'luft/dashboard-completed/GET_COMPARATIVE_BY_FAILURE';

const CHANGE_DETAILS_RANGE = 'luft/dashboard-completed/CHANGE_DETAILS_RANGE';
const CHANGE_DETAILS = 'luft/dashboard-completed/CHANGE_DETAILS';
const CHANGE_COMPARATIVE_TYPE =
  'luft/dashboard-completed/CHANGE_COMPARATIVE_TYPE';

const CHANGE_CHART_VIEW_UNIT =
  'luft/dashboard-completed/CHANGE_CHART_VIEW_UNIT';
const CHANGE_CHART_IS_RELATIVE =
  'luft/dashboard-completed CHANGE_CHART_IS_RELATIVE';

// maps

export const chartViewUnits = {
  QTY: 'QTY',
  WEIGHT: 'WEIGHT',
  VALUE: 'VALUE',
};

export const detailsRanges = {
  WEEK: 'WEEK',
  MONTH: 'MONTH',
};

export const comparativeTypes = {
  SHIPPING_COMPANY: '1',
  CUSTOMER: '2',
  REGION: '3',
  UF: '4',
};

export const comparativeTypesTranskey = {
  [comparativeTypes.SHIPPING_COMPANY]: 'Transportadora',
  [comparativeTypes.CUSTOMER]: 'Cliente',
  [comparativeTypes.REGION]: 'Regiões',
  [comparativeTypes.UF]: 'Estados',
};

// reducer

const initialState = {
  bigNumbers: {
    isFetching: false,
    error: '',
    requested: '',
    received: '',
    data: {
      nfQuantity: 0,
      transportedTotalValueNf: 0,
      averageTotalValuePerNf: 0,
      transportedWeightNF: 0,
      averageTransportedWeightPerNF: 0,
      performanceOnTime: 0,
      performanceOnTimePc: 0,
      performanceLate: 0,
      comparativeEarly: 0,
      comparativeOnTime: 0,
      comparativeLate: 0,
    },
  },
  periodList: {
    isFetching: false,
    error: '',
    requested: '',
    received: '',
    list: [],
  },
  comparative: {
    isFetching: false,
    error: '',
    requested: '',
    received: '',
    data: {},
  },
  comparativeBy: {
    isFetching: false,
    error: '',
    requested: '',
    received: '',
    data: {},
  },
  chartOptions: {
    viewUnit: chartViewUnits.QTY,
    isRelative: false,
  },
  filters: {
    initialPeriod: moment()
      .subtract(1, 'month')
      .add(1, 'day')
      .format('YYYY-MM-DD'),
    finalPeriod: moment().format('YYYY-MM-DD'),
    listCompany: [],
    listCustomers: [],
    listUf: [],
    listRegion: [],
    manifestType: '',
    keyAccount: '',
  },
  details: {
    range: detailsRanges.WEEK,
    currentRangeId: 0, // format = isWeek ? wwgggg || MMYYYY
    comparativeType: '',
    initialSubPeriod: '',
    finalSubPeriod: '',
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    // big numbers

    case GET_BIG_NUMBERS:
      return {
        ...state,
        bigNumbers: {
          ...state.bigNumbers,
          requested: action.requested,
          isFetching: true,
          error: '',
        },
      };

    case GET_BIG_NUMBERS_SUCCESS: {
      const { data, requested } = action;

      return {
        ...state,
        bigNumbers: {
          ...state.bigNumbers,
          isFetching: false,
          error: '',
          data:
            state.bigNumbers.requested === requested
              ? {
                  ...data,
                  averageTransportedWeightPerNF:
                    data.transportedWeightNF / data.nfQuantity,
                }
              : state.bigNumbers.data,
        },
      };
    }

    case GET_BIG_NUMBERS_FAILURE:
      return {
        ...state,
        bigNumbers: {
          ...state.bigNumbers,
          isFetching: false,
          error:
            state.bigNumbers.requested === action.requested
              ? action.error
              : state.bigNumbers.error,
        },
      };

    // period list

    case GET_PERIOD_LIST:
      return {
        ...state,
        periodList: {
          ...state.periodList,
          requested: action.requested,
          isFetching: true,
          error: '',
        },
      };

    case GET_PERIOD_LIST_SUCCESS:
      return {
        ...state,
        ...(state.periodList.requested === action.requested
          ? {
              periodList: {
                ...state.periodList,
                isFetching: false,
                error: '',
                received: moment().format(),
                list: action.list,
              },
              comparative: {
                ...state.comparative,
                data: {},
              },
              comparativeBy: {
                ...state.comparativeBy,
                data: {},
              },
              details: {
                ...state.details,
                currentRangeId: 0,
                initialSubPeriod: '',
                finalSubPeriod: '',
              },
            }
          : {}),
      };

    case GET_PERIOD_LIST_FAILURE:
      return {
        ...state,
        periodList: {
          ...state.periodList,
          isFetching: false,
          error:
            state.periodList.requested === action.requested
              ? action.error
              : state.periodList.error,
        },
      };

    // comparative

    case GET_COMPARATIVE:
      return {
        ...state,
        comparative: {
          ...state.comparative,
          requested: action.requested,
          isFetching: true,
          error: '',
        },
      };

    case GET_COMPARATIVE_SUCCESS: {
      const isLastRequest = state.comparative.requested === action.requested;

      return {
        ...state,
        comparative: {
          ...state.comparative,
          isFetching: isLastRequest ? false : state.comparative.isFetching,
          error: isLastRequest ? '' : state.comparative.error,
          data: {
            ...state.comparative.data,
            [action.range]: {
              ...state.comparative.data[action.range],
              [action.rangeId]: action.data,
            },
          },
        },
      };
    }

    case GET_COMPARATIVE_FAILURE:
      return {
        ...state,
        comparative: {
          ...state.comparative,
          isFetching: false,
          error: action.error,
        },
      };

    // comparative by

    case GET_COMPARATIVE_BY:
      return {
        ...state,
        comparativeBy: {
          ...state.comparativeBy,
          requested: action.requested,
          isFetching: true,
          error: '',
        },
      };

    case GET_COMPARATIVE_BY_SUCCESS: {
      const rangeData = state.comparativeBy.data[action.range];
      const rangeIdData = rangeData ? rangeData[action.rangeId] : {};
      const isLastRequest = state.comparativeBy.requested === action.requested;

      return {
        ...state,
        comparativeBy: {
          ...state.comparativeBy,
          isFetching: isLastRequest ? false : state.comparativeBy.isFetching,
          error: isLastRequest ? '' : state.comparativeBy.error,
          data: {
            ...state.comparativeBy.data,
            [action.range]: {
              ...rangeData,
              [action.rangeId]: {
                ...rangeIdData,
                [action.comparativeType]: action.list,
              },
            },
          },
        },
      };
    }

    case GET_COMPARATIVE_BY_FAILURE:
      return {
        ...state,
        comparativeBy: {
          ...state.comparativeBy,
          isFetching: false,
          error:
            state.comparativeBy.requested === action.requested
              ? action.error
              : state.comparativeBy.error,
        },
      };

    // details

    case CHANGE_DETAILS_RANGE:
      return {
        ...state,
        details: {
          ...state.details,
          range: action.range,
        },
      };

    case CHANGE_DETAILS:
      return {
        ...state,
        details: {
          ...state.details,
          currentRangeId: action.rangeId,
          initialSubPeriod: action.initialSubPeriod,
          finalSubPeriod: action.finalSubPeriod,
        },
      };

    case CHANGE_COMPARATIVE_TYPE:
      return {
        ...state,
        details: {
          ...state.details,
          comparativeType: action.comparativeType,
        },
      };

    // chart view

    case CHANGE_CHART_VIEW_UNIT:
      return {
        ...state,
        chartOptions: {
          ...state.chartOptions,
          viewUnit: action.viewUnit,
        },
      };

    case CHANGE_CHART_IS_RELATIVE:
      return {
        ...state,
        chartOptions: {
          ...state.chartOptions,
          isRelative: action.isRelative,
        },
      };

    // Default

    default:
      return state;
  }
}

export default reducer;

// actions creators

// big numbers

function _getBigNumbers(requested) {
  return {
    type: GET_BIG_NUMBERS,
    requested,
  };
}

function _getBigNumbersSuccess(data, requested) {
  return {
    type: GET_BIG_NUMBERS_SUCCESS,
    data,
    requested,
  };
}

function _getBigNumbersFailure(error, requested) {
  return {
    type: GET_BIG_NUMBERS_FAILURE,
    error,
    requested,
  };
}

// period list

function _getPeriodList(requested) {
  return {
    type: GET_PERIOD_LIST,
    requested,
  };
}

function _getPeriodListSuccess(list, requested) {
  return {
    type: GET_PERIOD_LIST_SUCCESS,
    list,
    requested,
  };
}

function _getPeriodListFailure(error, requested) {
  return {
    type: GET_PERIOD_LIST_FAILURE,
    error,
    requested,
  };
}

// comparative

function _getComparative(requested) {
  return {
    type: GET_COMPARATIVE,
    requested,
  };
}

function _getComparativeSuccess(data, range, rangeId, requested) {
  return {
    type: GET_COMPARATIVE_SUCCESS,
    data,
    range,
    rangeId,
    requested,
  };
}

function _getComparativeFailure(error, requested) {
  return {
    type: GET_COMPARATIVE_FAILURE,
    error,
    requested,
  };
}

// comparative by

function _getComparativeBy(requested) {
  return {
    type: GET_COMPARATIVE_BY,
    requested,
  };
}

function _getComparativeBySuccess(
  list,
  range,
  rangeId,
  comparativeType,
  requested,
) {
  return {
    type: GET_COMPARATIVE_BY_SUCCESS,
    list,
    range,
    rangeId,
    comparativeType,
    requested,
  };
}

function _getComparativeByFailure(error, requested) {
  return {
    type: GET_COMPARATIVE_BY_FAILURE,
    error,
    requested,
  };
}

// details

export function changeDetailsRange(range) {
  return {
    type: CHANGE_DETAILS_RANGE,
    range,
  };
}

export function changeDetails(rangeId, initialSubPeriod, finalSubPeriod) {
  return {
    type: CHANGE_DETAILS,
    rangeId,
    initialSubPeriod,
    finalSubPeriod,
  };
}

export function changeComparativeType(comparativeType) {
  return {
    type: CHANGE_COMPARATIVE_TYPE,
    comparativeType,
  };
}

// chart options

export function changeChartViewUnit(viewUnit) {
  return {
    type: CHANGE_CHART_VIEW_UNIT,
    viewUnit,
  };
}

export function changeChartIsRelative(isRelative) {
  return {
    type: CHANGE_CHART_IS_RELATIVE,
    isRelative,
  };
}

// thunk action creators

export function getBigNumbers(usePeriodSelecionDates = false) {
  return function (dispatch, getState) {
    const requested = moment().format();
    dispatch(_getBigNumbers(requested));

    (async () => {
      // extract params from state
      const {
        byDate,
        selectedPeriodInitialDate,
        selectedPeriodFinalDate,
        initialPeriod,
        finalPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
        carrierList,
      } = getState().dashboardFilters.filters;

      const { activeCompanyId, userType } = getState().auth;

      const params = {
        byDate,
        initialPeriod: usePeriodSelecionDates
          ? selectedPeriodInitialDate
          : initialPeriod,
        finalPeriod: usePeriodSelecionDates
          ? selectedPeriodFinalDate
          : finalPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
        carrierList,
        companyId:
          userType === USER_TYPES.CUSTOMER_SERVICE_USER
            ? activeCompanyId
            : null,
      };

      try {
        const http = new DynamicAPI('v4');
        const response = await http.get(
          '/Invoice/GetBigNumbers',
          params,
        );
        dispatch(_getBigNumbersSuccess(response.data, requested));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getBigNumbersFailure(error.message, requested),
        );
      }
    })();
  };
}

export function getPeriodList() {
  return function (dispatch, getState) {
    const requested = moment().format();
    dispatch(_getPeriodList(requested));

    (async () => {
      // extract params from state
      const {
        byDate,
        initialPeriod,
        finalPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
        carrierList,
      } = getState().dashboardFilters.filters;

      const { activeCompanyId, userType } = getState().auth;

      const params = {
        byDate,
        initialPeriod,
        finalPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
        carrierList,
        companyId:
          userType === USER_TYPES.CUSTOMER_SERVICE_USER
            ? activeCompanyId
            : null,
      };

      try {
        const http = new DynamicAPI('v4');
        const response = await http.get(
          '/Invoice/GetPeriodList', 
          params,
        );
        dispatch(
          _getPeriodListSuccess(response.data.periodChartData, requested),
        );
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getPeriodListFailure(error.message, requested),
        );
      }
    })();
  };
}

export function getComparative() {
  return function (dispatch, getState) {
    const requested = moment().format();
    dispatch(_getComparative(requested));

    (async () => {
      // extract params from state
      const {
        byDate,
        initialPeriod,
        finalPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
        carrierList,
      } = getState().dashboardFilters.filters;

      const { activeCompanyId, userType } = getState().auth;

      const { range, currentRangeId, initialSubPeriod, finalSubPeriod } =
        getState().dashboardCompleted.details;

      const params = {
        byDate,
        initialPeriod,
        finalPeriod,
        initialSubPeriod,
        finalSubPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
        carrierList,
        companyId:
          userType === USER_TYPES.CUSTOMER_SERVICE_USER
            ? activeCompanyId
            : null,
      };

      try {
        const http = new DynamicAPI('v4');
        const response = await http.get(
          '/Invoice/GetComparative', 
          params,
        );
        dispatch(
          _getComparativeSuccess(
            response.data,
            range,
            currentRangeId,
            requested,
          ),
        );
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getComparativeFailure(error.message, requested),
        );
      }
    })();
  };
}

export function getComparativeBy() {
  return function (dispatch, getState) {
    const requested = moment().format();
    dispatch(_getComparativeBy(requested));

    (async () => {
      // extract params from state
      const {
        byDate,
        initialPeriod,
        finalPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
      } = getState().dashboardFilters.filters;

      const { activeCompanyId, userType } = getState().auth;

      const { range, currentRangeId, comparativeType } =
        getState().dashboardCompleted.details;

      const params = {
        byDate,
        initialPeriod,
        finalPeriod,
        comparativeType,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
        companyId:
          userType === USER_TYPES.CUSTOMER_SERVICE_USER
            ? activeCompanyId
            : null,
      };

      try {
        const http = new DynamicAPI('v3');
        const response = await http.get(
          '/Invoice/GetComparativeCompanies', 
          params,
        );
        dispatch(
          _getComparativeBySuccess(
            response.data.comparative,
            range,
            currentRangeId,
            comparativeType,
            requested,
          ),
        );
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getComparativeByFailure(error.message, requested),
        );
      }
    })();
  };
}
